<!-- Security Data Upload Modal -->
<div #SecurityDataUploadComponent id="PG_LoanEntityModify" class="glb_paddingBottomMD" [ngClass]="ModalIdentifier">
    <!-- close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
    <div class="glb_customFlexRow glb_paddingBottomMD">
        <div class="glb_headerBarBGDark glb_customFlexRow justify-content-end col-12" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start align-self-bottom" style="padding-left: 50px; padding-bottom: 0px;">
                <button id="BTN_CloseSecurityDataUpload" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark"></fa-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="glb_customFlexRow glb_boxedPadding" style="padding: 0.25em;padding-left: 30px;">
        <!-- the overflow: hidden stops the scrollbar for this section appearing (its not needed) -->
        <div class="glb_customFlexRow glb_Font modalTitle col-12">
            <div>Security Data Upload</div>
        </div>
    </div>

    <!-- This is the upload file control -->
    <div *ngIf="!IsFileImported" class="glb_customFlexRow glb_boxedPadding" style="padding: 0.25em;padding-left: 30px;">
        <div class="col-8">
            <div class="glb_Font glb_inputFieldLabel glb_customFlexRow align-items-center">Choose a file
                <button id="BTN_Download" class="btn glb_SmallText" style="padding-left:1px;"
                    (click)="ExcelFormatModal_Open(ExpectedExcelFormatTemplate)">
                    <fa-icon class="fa-fw glb_fixedSizeIcons" [icon]="['fal', 'circle-question']" matTooltip="View Expected Excel File Format">
                    </fa-icon>
                </button>
            </div>
            <p-fileUpload accept=".xlsx,.xls" id="excelFileInput" chooseIcon="pi pi-folder" [multiple]="false" maxFileSize="15728640"
                (onSelect)="File_OnSelected($event)" [showCancelButton]="false" [showUploadButton]="false" chooseLabel=" " class="p-customFileUpload">
                <ng-template pTemplate="content">
                </ng-template>
            </p-fileUpload>
        </div>
    </div>

    <!-- Import Button -->
    <div *ngIf="!IsFileImported" class="glb_customFlexRow glb_boxedPadding" style="padding: 0.25em;padding-left: 30px;">
        <div class="col-8 glb_paddingZeroOffset d-grid">
            <button [disabled]="!SelectedFile" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                [ngClass]="CSS_Disable()" (click)="File_Import(ValidationsAndUploadTemplate)">
                <span class="glb_Font glb_smallerText">Import Data</span>
            </button>
        </div>

    </div>
</div>

<!-- Validations + Upload section -->
<ng-template #ValidationsAndUploadTemplate>
    <div class="">
        <div class="glb_headerBarBGDark glb_customFlexRow justify-content-end col-12" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start align-self-bottom" style="padding-left: 50px; padding-bottom: 0px;">
                <button id="BTN_CloseUploadTemplate" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="ResetInputs();globalFunctions.FeatureModal_Close(ValidateAndUploadModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark"></fa-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Selected File Name -->
    <div class="glb_customFlexRow col-12 glb_boxedPaddingNarrow">
        <div *ngIf="FileName" class="glb_customFlexRow col-10 row-cols-1 advanceHighlight justify-content-start align-items-center">
            <span class="glb_Font">Selected File :
                {{FileName}}</span>
        </div>
        <div class="glb_customFlexRow col-2 justify-content-end align-items-center">
            <div
                class="glb_customFlexRow col-6 row-cols-1 glb_paddingTopSM justify-content-end align-items-center glb_paddingBottomMD glb_PaddingHorizontalXS">
                <button id="BTN_Cancel" (click)="ResetInputs();globalFunctions.FeatureModal_Close(ValidateAndUploadModalIdentifier)"
                    class="glb_clickableIconButtonStyle glb_standardButton btn glb_BGColorSkin align-self-right text-white">
                    <span class="glb_Font glb_smallerText">Cancel</span>
                </button>
            </div>

            <!-- Ready to validate -->
            <div *ngIf="HasDataToProcess && !IsValidated"
                class="glb_customFlexRow col-6 row-cols-1 glb_paddingTopSM justify-content-end align-items-center glb_paddingBottomMD">
                <button id="BTN_Validate" [disabled]="IsValidated || IsProcessing || ProcessingComplete" (click)="Validate_Data()"
                    class="glb_clickableIconButtonStyle glb_standardButton btn glb_BGColorSkin align-self-right text-white">
                    <span class="glb_Font glb_smallerText">Validate</span>
                </button>
            </div>

            <!-- Ready to upload -->
            <div *ngIf="HasDataToProcess && IsValidated"
                class="glb_customFlexRow col-6 row-cols-1 glb_paddingTopSM justify-content-end align-items-center glb_paddingBottomMD">
                <button id="BTN_Upload" [disabled]="!IsValidated" (click)="Upload_Process()"
                    class="glb_clickableIconButtonStyle glb_standardButton btn glb_BGColorSkin align-self-right text-white">
                    <span class="glb_Font glb_smallerText">Upload</span>
                </button>
            </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="ErrorMessage" class="col-12 glb_paddingBottomMD">
            <div class="alert alert-danger" role="alert">
                <strong>Error:</strong> {{ErrorMessage}}

                <!-- Missing Columns -->
                <div *ngIf="MissingColumns.length > 0" class="glb_paddingTopSM">
                    <strong>Missing Required Columns:</strong>
                    <ul class="validation-list">
                        <li *ngFor="let col of MissingColumns">{{col}}</li>
                    </ul>
                </div>

                <!-- Invalid Columns (case mismatch) -->
                <div *ngIf="InvalidColumns.length > 0" class="glb_paddingTopSM">
                    <strong>Invalid Column Names:</strong>
                    <ul class="validation-list">
                        <li *ngFor="let col of InvalidColumns">{{col}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Warning Message -->
        <div *ngIf="WarningMessage && !ErrorMessage" class="alert alert-warning col-12 glb_paddingBottomMD glb_customFlexRow">
            <div class="glb_customFlexRow glb_paddingHorizontalMD col-12">
                <strong>⚠️ Warning:</strong> {{WarningMessage}}
            </div>
            <!-- Extra Columns -->
            <div *ngIf="ExtraColumns.length > 0" class="glb_customFlexRow col-12">
                <div class="glb_customFlexRow col-12">
                    The following column(s) are displayed in RED and will be IGNORED in processing:
                </div>
                <div class="glb_customFlexRow col-12 glb_PaddingHorizontalMD">
                    <ul class="validation-list">
                        <li *ngFor="let col of ExtraColumns" class="extra-column-highlight">{{col}}</li>
                    </ul>
                </div>
                <span class="gl_font glb_SmallText">
                    Only the expected columns (in black headers) will be processed. Extra columns are shown for reference
                    only.
                </span>
            </div>
        </div>

        <!-- Informational Messages -->
        <div *ngIf="IsFileImported" class="glb_customFlexRow col-12 row-cols-1 justify-content-center glb_paddingBottomMD">
            <!-- Success Message -->
            <!--   <div *ngIf="MissingLoanIDCount == 0 && TotalRowsInFile == Get_SelectedRowsCount()" class="col-12 glb_paddingBottomMD">
                <div class="alert alert-success" role="alert">
                    ✅ File imported successfully! Showing data from the first sheet.
                </div>
            </div> -->

            <!-- Data Summary -->
            <div class="glb_customFlexRow col-12 glb_paddingTopMD glb_paddingBottomMD alert alert-info">
                <div class="justify-content-start">
                    <span class="glb_Font">
                        ℹ️ Total Rows: {{ExcelData.length}} | <span style="color: red;">Rows having error(s): {{ExcludedRowsCount}} </span>| Total
                        Columns:
                        {{ColumnHeaders.length}}
                        <span *ngIf="ExcludedRowsCount > 0"><br /> ℹ️ Rows Excluded: {{ExcludedRowsCount}}. Please
                            review
                            excel file and upload again.</span>
                    </span>
                </div>
                <!-- Ready to download data and the error messages -->
                <div *ngIf="!HasDataToProcess"
                    class="input-group-sm col-2 justify-content-start glb_PaddingHorizontalXS glb_TinyText justify-content-start align-content-end">
                    <button id="BTN_Download" (click)="Download_Data()"
                        class="glb_clickableIconButtonStyle  glb_BGColorSkin align-self-right text-white">
                        <fa-icon [icon]="['fal', 'download']" class="fa-fw glb_fixedSizeIcons" matTooltip="Click to Download">
                        </fa-icon>
                    </button>
                </div>
            </div>

            <!-- Data Table -->
            <div class="col-12" style="overflow-x: auto; max-height: 500px; overflow-y: auto;">
                <table class="table table-bordered table-striped table-hover" style="background-color: white;">
                    <thead style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1;" class="glb_Font glb_XSBold">
                        <tr>
                            <!-- Select All Checkbox Column -->
                            <th class="">
                                <!--  <input type="checkbox" [(ngModel)]="AllRowsSelected" (change)="ToggleAll_Selection()" title="Select/Deselect All"> -->
                                <span class="checkbox-label">Row Number</span>
                            </th>

                            <!-- Status Column -->
                            <th class="">
                                Status
                            </th>

                            <!-- Data Columns -->
                            <th *ngFor="let header of ColumnHeaders" [ngClass]="{'extra-column-header': Column_IsExtra(header)}" class="">
                                {{header}}
                                <span *ngIf="Column_IsExtra(header)" class="extra-badge glb_XSBold">IGNORED</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of ExcelData; let i = index" [ngClass]="{
                                  'row-deselected': !row.isSelected}">
                            <!-- Row Index Cell -->
                            <td class="checkbox-column">
                                <span>
                                    {{row.rowIndex}}
                                </span>
                            </td><!-- Status Cell -->
                            <td class="glb_Font glb_smallerText status-column">
                                <span class="status-badge" [ngClass]="{
                                            'status-ready': row.status === 'Ready for Processing',
                                            'status-complete': row.status === 'Complete' || row.status === 'Success',
                                            'status-error': row.status.includes('Error')|| row.status === 'Error' || row.status === 'Not Ready for Processing'
                                          }">
                                    {{row.status}}
                                </span>
                            </td>

                            <!-- Data Cells -->
                            <td *ngFor="let header of ColumnHeaders" [ngClass]="{'extra-column-cell': Column_IsExtra(header)}"
                                class="glb_Font glb_smallerText">
                                {{row.data[header]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</ng-template>

<!-- Expected Excel Format modal-->
<ng-template #ExpectedExcelFormatTemplate>
    <div class="glb_customFlexRow glb_paddingBottomMD glb_boxedPaddingXS">
        <div class="glb_headerBarBGDark glb_customFlexRow justify-content-end col-12" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start align-self-bottom" style="padding-bottom: 0px;">
                <button id="BTN_CloseLoanEntityModify" tabindex="15"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(ExcelFormatModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark"></fa-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="glb_Font glb_customFlexRow row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 align-items-end glb_PaddingHorizontalMD">

        <!-- Title -->
        <div class="titleClass glb_TitleMD glb_boxedPaddingNarrow glb_Font modalTitle ">Expected Excel Format</div>

        <div
            class="glb_customFlexRow justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-xs-start align-items-center">
            <div class="input-group input-group-sm col-8 col-xs-8 col-sm-8 col-md-8 col-lg-6 justify-content-end">
                <button id="BTN_Download" class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline"
                    type="button" (click)="DownloadSampleCSV()">
                    <fa-icon class="fa-fw glb_fixedSizeIcons" [icon]="['fal', 'download']" matTooltip="Click to Download">
                    </fa-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="glb_boxedPadding glb_Font glb_Font">
        <div class="glb_customFlexRow col-12">
            <div class="glb_customFlexRow glb_paddingTopSM">
                <table class="table table-bordered" style="background-color: white;color:black;">
                    <thead>
                        <tr>
                            <th *ngFor="let header of Get_ExpectedHeaders()">{{header}}</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <p>NOTE: Column names are case-sensitive and must match exactly. Your Excel file's first row should contain these headers in this order.
            </p>
        </div>
    </div>
</ng-template>